module.exports = __webpack_public_path__ + "img/20200905_140457.b16ed4e3.jpg";